import ErrorBoundary from "../../utils/ErrorBoundary";
import React, {lazy, Suspense, useEffect, useState} from "react";

const LazyCrossSelling = lazy(() => import("./LazyCrossSelling"));

const CrossSelling = () => {
  const [element, setElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const stringOfAllElementIds = [
      "ParentCategoryProductsContainer",
      "PASimilarProducts",
      "PABoughtTogether",
      "PARecommendations",
    ].map(id => `#${id}`).join(", ");
    const anyElement = document.body.querySelector<HTMLElement>(stringOfAllElementIds);

    setElement(anyElement);
  }, []);

  if (!element) {
    return null;
  }

  return (
    <ErrorBoundary fallback={null} occurrence="CrossSellings">
      <Suspense fallback={null}>
        <LazyCrossSelling />
      </Suspense>
    </ErrorBoundary>
  );
};

export default CrossSelling;
